export default "__VITE_ASSET__DSqdw_sx__"